/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
/**
 * The internal dependencies.
 */
import TaskData from '../../../containers/task/working/base';
import TaskReport from '../../../containers/task/working/report';
import TaskWarning from '../../../containers/task/working/warning';
import {getTasksCurrent} from '../../../store/tasks/selectors';
import {getTaskViewCurrent} from '../../../store/task-view/selectors';
import {getTaskErrormessage, getTaskErrormessageRevieved} from "../../../store/tasks/selectors";

class Task extends React.Component {
    renderWarning() {
        return <TaskWarning/>;
    }

    renderBasic() {
        return <TaskData/>;
    }

    renderReport() {
        return <TaskReport/>;
    }

    render() {
        const {task, view, errormessage, errormessageRevieved} = this.props;

        if (view === 'report') {
            return this.renderReport();
        }

        if ((errormessageRevieved && errormessage.length === 0) || !errormessageRevieved) {
            return this.renderBasic();
        }

        if ((errormessageRevieved && errormessage.length > 0)) {
            return this.renderWarning();
        }
    }
}

export default connect(
    (state) => ({
        task: getTasksCurrent(state),
        view: getTaskViewCurrent(state),
        errormessage: getTaskErrormessage(state),
        errormessageRevieved: getTaskErrormessageRevieved(state),
    })
)(Task);



// WEBPACK FOOTER //
// ./src/containers/task/working/index.js